module.exports = __webpack_public_path__ + "static/img/2.14a5ab5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mockups/screenshots/2.jpg
// module id = ZtR2
// module chunks = 0